import { useState } from 'react'
import type { Rule, UpdateRulePayload } from '@/types/strategy'
import { ConfigFieldEditor } from './ConfigFieldEditor'

interface RuleEditCardProps {
  rule: Rule
  onChange: (patch: UpdateRulePayload) => void
}

export function RuleEditCard({ rule, onChange }: RuleEditCardProps) {
  const [active, setActive] = useState(rule.active)
  const [config, setConfig] = useState<Record<string, unknown>>(rule.config)

  function emitDiff(nextConfig: Record<string, unknown>, nextActive: boolean) {
    const patch: UpdateRulePayload = {}
    if (JSON.stringify(nextConfig) !== JSON.stringify(rule.config)) {
      patch.config = nextConfig
    }
    if (nextActive !== rule.active) {
      patch.active = nextActive
    }
    onChange(patch)
  }

  function handleActiveChange(next: boolean) {
    setActive(next)
    emitDiff(config, next)
  }

  function handleConfigKeyChange(key: string, next: unknown) {
    const updated = { ...config, [key]: next }
    setConfig(updated)
    emitDiff(updated, active)
  }

  return (
    <section className="hairline mb-4 flex flex-col gap-3 border bg-panel p-4">
      <header className="flex items-center justify-between">
        <div>
          <p className="tracked-caps text-xs text-muted">{rule.category}</p>
          <h3 className="text-sm text-ink">{rule.name}</h3>
        </div>
        <label className="flex items-center gap-2 text-xs text-muted">
          <input
            type="checkbox"
            checked={active}
            onChange={(e) => handleActiveChange(e.target.checked)}
            aria-label="aktiv"
          />
          aktiv
        </label>
      </header>
      <div className="grid gap-3 sm:grid-cols-2">
        {Object.entries(config).map(([key, val]) => (
          <ConfigFieldEditor
            key={key}
            fieldKey={key}
            value={val}
            onChange={(next) => handleConfigKeyChange(key, next)}
          />
        ))}
      </div>
    </section>
  )
}
